import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { QuoteUserDefinedStatus } from "src/app/models/quote/quote-user-defined-status";
import { QuoteService } from "src/app/services/quote/quote.service";

@Injectable()
export class QuoteUserDefinedStatusResolver  {
    
    constructor(private quoteService: QuoteService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<QuoteUserDefinedStatus>> {
        const response = this.quoteService.getQuoteUserDefinedStatusDescription().pipe(map(response => { 
            if (response.success) {
                return response.payload;
            }
            else {
                return <QuoteUserDefinedStatus> { description: '' };
            }
        }));
        const responsePromise = new Promise<Observable<QuoteUserDefinedStatus>>((resolve, reject) => { resolve( response )});
        return responsePromise;
    }

}